import { Component } from '@verndale/core';

class ChapterMediaRow extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      imagesContainer: this.el.querySelector<HTMLElement>(
        '.chapter-media-row__media'
      )
    };
  }
}

export default ChapterMediaRow;
